import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
};

export const deviceTokenSlice = createSlice({
  name: "deviceToken",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
    },
  },
});

export const { setToken, clearToken } = deviceTokenSlice.actions;
export default deviceTokenSlice.reducer;
